import { Button, Box, Typography } from '@material-ui/core';
import { Link } from 'components';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useStyles } from './menu-items.style';
import WorkIcon from '@material-ui/icons/Work';
import BusinessIcon from '@material-ui/icons/Business';

export const AdminMenuItems: React.FC<{ handleClose?: () => void }> = ({ handleClose }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const menuItems = [
        {
            title: t('mainProfileMenu:jobPostings'),
            icon: <WorkIcon />,
            route: '/d/job/list?status=ON_MODERATION',
        },
        {
            title: t('mainProfileMenu:companies'),
            icon: <BusinessIcon />,
            route: '/d/companies',
        },
    ];
    return (
        <>
            {menuItems.map((item, index) => (
                <Link key={index} to={item.route}>
                    <Button
                        onClick={handleClose}
                        startIcon={<Box className={classes.iconContainer}>{item.icon}</Box>}
                        className={classes.userMenuItem}
                    >
                        <Typography className={classes.userMenuItemText}>{item.title}</Typography>
                    </Button>
                </Link>
            ))}
        </>
    );
};
